<template>
  <Element
    :section="section"
    type="element"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings()"
  >
    <ContentEditableV4
      :sid="section.sid"
      :content="section.options.content"
    />
  </Element>
</template>

<script>
import SectionMixin from '@/components/mixins/SectionMixin'
import Element from '@/components/builder/utils/Element.vue'
import ContentEditableV4 from '@/components/builder/utils/ContentEditableV4.vue'

export default {
  name: 'ElHeadlineV3',
  mixins: [SectionMixin],
  components: {
    ContentEditableV4,
    Element
  }
}
</script>